package devxertech.com.pages.blogs


import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onMouseEnter
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import devxertech.com.section.onDesktopNavigationClick
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.H2
import com.varabyte.kobweb.core.rememberPageContext
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba

@Composable
fun CommonInfoCard(
    imageUrl: String,
    date: String,
    title: String,
    linkText: String,
    linkUrl: String,
    imageAlt: String = ""
) {
    val breakpoint = rememberBreakpoint()
    val palette = ColorMode.current.toSitePalette()
    val ctx = rememberPageContext()
    var isHovered by remember { mutableStateOf(false) }


    A(href = linkUrl, attrs = Modifier
            .attrsModifier { attr("data-blog-card", "") }
            .width(if (breakpoint == Breakpoint.MD || breakpoint == Breakpoint.LG) 48.percent else if (breakpoint < Breakpoint.MD) 100.percent else 31.percent)
            .height(if (breakpoint >= Breakpoint.LG) 390.px else 396.px)
            .styleModifier { property("display", "block"); property("color", "inherit"); property("text-decoration", "none") }
            .borderRadius(12.px)
            .cursor(Cursor.Pointer)
            .boxShadow(
                offsetX = 0.px,
                offsetY = 4.px,
                blurRadius = 19.3.px,
                spreadRadius = 0.px,
                color = rgba(0, 0, 0, 0.09)
            )
            .transition(transition = com.varabyte.kobweb.compose.css.Transition.of("transform", duration = 300.ms))
            .transform {
                scale(if (isHovered) 1.05 else 1.0)
            }
            .onMouseEnter {
                isHovered = true
                prefetchPublishedPost(linkUrl.substringAfterLast('/'))
            }
            .onMouseLeave { isHovered = false }
            .overflow(Overflow.Hidden)
            .backgroundColor(palette.modalBackgroundColor.rgb)
            .margin(bottom = 20.px)
            .onDesktopNavigationClick { ctx.router.navigateTo(linkUrl) }
            .toAttrs()) {
        Column(
            modifier = Modifier.fillMaxSize(),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Top
        ) {
            // 🖼️ Image Section - Fixed height
            BlogImageSlot(
                url = imageUrl,
                fallbackUrl = Res.Image.blog_header_2,
                alt = imageAlt,
                height = "220px",
            )

            // 📅 Content Section - Takes remaining space
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(20.px)
                    .weight(1f),
                horizontalAlignment = Alignment.Start,
                verticalArrangement = Arrangement.Top
            ) {
                // Text Content
                Column(
                    modifier = Modifier.fillMaxWidth()
                ) {
                    SpanText(
                        text = date,
                        modifier = Modifier
                            .fontFamily(Constants.FONT_FAMILY)
                            .fontSize(14.px)
                            .color(palette.commonSecondaryButtonColor.rgb)
                    )

                    H2(attrs = Modifier
                            .fontFamily(Constants.FONT_FAMILY)
                            .fontSize(18.px)
                            .lineHeight(1.2)
                            .height(44.px)
                            .margin(top = 8.px, bottom = 8.px)
                            .fontWeight(FontWeight.Bold)
                            .color(palette.commonSecondaryButtonColor.rgb)
                            .fillMaxWidth()
                            .styleModifier {
                                property("display", "-webkit-box")
                                property("-webkit-box-orient", "vertical")
                                property("-webkit-line-clamp", "2")
                                property("line-clamp", "2")
                                property("overflow", "hidden")
                            }
                            .toAttrs()) { org.jetbrains.compose.web.dom.Text(title) }
                }

                // 🔗 Link Section - Always at the bottom
                Box(
                    modifier = Modifier.fillMaxWidth().styleModifier {
                        property("margin-top", "auto")
                    },
                    contentAlignment = Alignment.TopStart
                ) {
                        Row(
                            modifier = Modifier.cursor(Cursor.Pointer),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            SpanText(
                                text = linkText,
                                modifier = Modifier
                                    .fontFamily(Constants.FONT_FAMILY)
                                    .fontSize(15.px)
                                    .color(palette.primary.rgb)
                            )
                            SpanText(" →", modifier = Modifier.color(palette.primary.rgb))
                        }
                }
            }
        }
    }
}
